module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Tablet-Banner@1x.1797cb4d.jpg";